import { RunningExperiments, useExperiments } from 'state/experiments';

export const useRewardsPageRedesignPhaseTwoExperiment = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.RewardsPageRedesignPhaseTwo, 'treatment');
};
